import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';

import icon from "../../../assets/imgs/search-icon.png";
import './CustomAutocomplete.scss';

class CustomAutocomplete extends Component {

  static propTypes = {
    items: PropTypes.array,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
    placeholder: PropTypes.string,
    propertyToFilterBy: PropTypes.string
  };

  static defaultProps = {
    items: [],
    onChange: ()=> {},
    onSelect: ()=> {},
    placeholder: "Search", 
    propertyToFilterBy: ""   
  }

  state = {
    value: "",
    filteredItems: [],
    shouldDisplayList: false
  };

  componentDidUpdate(prevProps) {
    const { items, initialValue } = this.props;
    if (items.length !== prevProps.items.length) {
      this.setState({ // eslint-disable-line
        filteredItems: [...items] 
      });
    };
    if(prevProps.initialValue !== initialValue) {
      this.setState({
        value: initialValue
      });
    }
  };

  handleChange = event => {
    const { propertyToFilterBy, items, onChange } = this.props;
    const { target: { value } } = event;
    const newFilteredItems = items.filter(item => 
      item[propertyToFilterBy] ? item[propertyToFilterBy].toLowerCase().includes(value.toLowerCase()) : false
    ); 
    this.setState({ 
      value,
      filteredItems: newFilteredItems, 
      shouldDisplayList: !!value
    });
    
    if (onChange) {
      onChange(value, newFilteredItems)
    }
  };

  handleClick = item => {
    const { onSelect, propertyToFilterBy } = this.props;
    this.setState({
      value: item[propertyToFilterBy], 
      shouldDisplayList: false
    })
    onSelect(item)
  }

  handleClickOutside = ()=> {
    const { shouldDisplayList } = this.state;
    if (shouldDisplayList) {
      this.setState({
        shouldDisplayList: false
      });
    };
  };

  render () {
    const { propertyToFilterBy, placeholder } = this.props;
    const { value, filteredItems, shouldDisplayList } = this.state;
    return (
      <div className="custom-auto-complete">
        <div className="custom-auto-complete__input-container">
          <input 
            className="custom-auto-complete__input-container__input" 
            value={value} 
            placeholder={placeholder}
            onChange={event => this.handleChange(event)}
          />
          <img className="custom-auto-complete__input-container__icon" src={icon} alt=""/>
        </div>
        {shouldDisplayList &&
          <OutsideClickHandler
            onOutsideClick={this.handleClickOutside}
          >
            <div className="custom-auto-complete__items-list">
              {filteredItems.map(item =>
                <button
                  key={item[propertyToFilterBy]} 
                  className="custom-auto-complete__items-list__button"
                  type="button" 
                  onClick={()=> this.handleClick(item)}
                >
                  <span>{item[propertyToFilterBy]}</span>
                </button> 
              )}
            </div>
          </OutsideClickHandler>
        }
      </div>
    );
  };
};

export default CustomAutocomplete;